import { ReactNode, createContext, useContext } from 'react';
import { noop } from '@synergy/utils';

import { FilterValueMap } from '../models/filter-value-map';

// TODO: Refactor to use new filter-item with display value instead of cache

interface FilterContextData {
    // Ptimary context data
    filter: URLSearchParams;
    updateFilter: (filter: URLSearchParams) => void;
    reset: () => void;

    // Helper functions for displaying and caching filter values
    registerFilterMap: (filterKey: string, map: FilterValueMap) => void;
    getDisplayValue: (filterKey: string, value: unknown) => ReactNode;
    updateCache: (key: string, value: unknown) => void;
    getFromCache: (key: string) => unknown;
}

export const FilterContext = createContext<FilterContextData>({
    filter: new URLSearchParams(),
    updateFilter: noop,
    reset: noop,

    registerFilterMap: noop,
    getDisplayValue: () => '',
    updateCache: noop,
    getFromCache: () => null,
});

export const useFilter = () => useContext(FilterContext);

export const FilterHelper = FilterContext.Consumer;
